import { HourglassBottomTwoTone, HourglassTopTwoTone } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import HourGlassRoundedTwoTonedTop from "./Icons/RoundedTwoToneHourglassTop";
import HourGlassRoundedTwoTonedBottom from "./Icons/RoundedTwoToneHourglassBottom";

const iconStyle = { width: 48, height: 48, color: '#83418370' };
const width = 48;
const height = 48;
const rotationSpeed = 240 / 2;
const hold = 640 / 2;
const glassColor = "#8f4e8f8c"
const sandColor = "#bd80bd77"

export default function LoadingPageSpinner() {
    const [phase, setPhase] = useState(0);
    const [entered, setEntered] = useState(false);

    useEffect(() => {
        const id = requestAnimationFrame(() => {
            setEntered(true);
        });

        return () => cancelAnimationFrame(id);
    }, []);

    useEffect(() => {
        const durations = [
            hold,
            hold,
            rotationSpeed,
            hold,
            hold,
            rotationSpeed,
        ];

        const timer = setTimeout(() => {
            setPhase((prev) => (prev + 1) % 6);
        }, durations[phase]);

        return () => clearTimeout(timer);
    }, [phase]);

    const showTop = phase === 0 || phase === 4 || phase === 5;
    const rotation =
        phase === 2 || phase === 3 || phase === 4
            ? "rotate(180deg)"
            : "rotate(0deg)";

    return (
        <Box
            sx={{
                height: "100dvh",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f5f5f5",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: entered ? 1 : 0,
                    transform: `${rotation} ${entered ? "scale(1.2)" : "scale(0.1)"}`,
                    transition: entered
                        ? `opacity 120ms ease-out, transform 180ms ease-out`
                        : "none",
                    transformOrigin: "center",

                    animation: entered ? "bounce 780ms ease-in-out infinite" : "none",
                    "@keyframes bounce": {
                        "0%, 100%": { scale: 1 },
                        "50%": { scale: 1.06 },
                        "60%": { scale: 0.6 },
                    },
                }}
            >
                {showTop ? (
                    <HourGlassRoundedTwoTonedTop glassColor={glassColor} sandColor={sandColor} width={width.toString()} height={height.toString()} />
                ) : (
                    <HourGlassRoundedTwoTonedBottom glassColor={glassColor} sandColor={sandColor} width={width.toString()} height={height.toString()} />
                )}
            </Box>
        </Box>
    );
}